import { icons } from "../components/Icon/iconsList";

export type WebsiteSectionsProps = {
  icon?: keyof typeof icons;
  title: string;
  description?: string;
  url: string;
  isDisabled?: boolean;
  comingSoon?: boolean;
  slug?: string;
  mobileTitle?: string;
};

export const websiteSections = (basePath: string): WebsiteSectionsProps[] => [
  {
    title: "The basics",
    slug: "basics",
    url: basePath + "/website/edit/basics",
    icon: "bigDay",
    mobileTitle: "basics",
  },
  {
    title: "Love Story",
    slug: "love-story",
    url: basePath + "/website/edit/love-story",
    icon: "couple",
    mobileTitle: "our story",
  },
  {
    title: "Aso Ebi",
    slug: "aso-ebi",
    url: basePath + "/website/edit/aso-ebi",
    icon: "goodStatus",
    mobileTitle: "aso ebi",
  },
  {
    title: "Event Schedule",
    slug: "event-schedule",
    url: basePath + "/website/edit/event-schedule",
    icon: "eventBusy",
    mobileTitle: "schedule",
  },
  {
    title: "Gallery",
    slug: "gallery",
    url: basePath + "/website/edit/gallery",
    icon: "gallery",
    mobileTitle: "gallery",
  },
  {
    title: "Gifting",
    slug: "gifting",
    url: basePath + "/website/edit/gifting",
    icon: "coins",
    mobileTitle: "gifting",
  },
  {
    title: "Q and A",
    slug: "q-and-a",
    url: basePath + "/website/edit/q-and-a",
    icon: "wellWishes",
    mobileTitle: "q and a",
  },
  {
    title: "Wedding Party",
    slug: "wedding-party",
    url: basePath + "/website/edit/wedding-party",
    icon: "people",
    mobileTitle: "w. party",
  },
];
